import { jsx as _jsx } from "react/jsx-runtime";
import { LinkIcon } from './styles';
export var linkAppearance = function (theme) {
  return function (color) {
    switch (color) {
      case 'download':
      case 'primary':
        {
          return {
            normal: theme.tokens.accent.base.primary.regular,
            hover: theme.tokens.accent.base.primary.strong
          };
        }
      case 'secondary':
        {
          return {
            normal: theme.tokens.accent.base.secondary.light,
            hover: theme.tokens.accent.base.secondary.regular
          };
        }
      case 'positive':
        {
          return {
            normal: theme.tokens.interface.feedback.positive.strong,
            hover: theme.tokens.interface.feedback.positive.regular
          };
        }
      case 'negative':
        {
          return {
            normal: theme.tokens.interface.feedback.negative.strong,
            hover: theme.tokens.interface.feedback.negative.regular
          };
        }
      case 'darker':
      default:
        {
          return {
            normal: theme.tokens.accent.base.primary.regular,
            hover: theme.tokens.accent.base.primary.strong
          };
        }
    }
  };
};
export var getRightIcon = function (role, icon, size) {
  var iconSize = size === 'small' ? 16 : 24;
  if (role === 'download') return _jsx(LinkIcon, {
    size: iconSize,
    type: "icon-download"
  });
  switch (icon) {
    case 'internal':
      return _jsx(LinkIcon, {
        size: iconSize,
        type: "icon-chevron-right-big"
      });
    case 'external':
      return _jsx(LinkIcon, {
        size: iconSize,
        type: "icon-external-link"
      });
    case 'back':
    case undefined:
      return null;
    default:
      return _jsx(LinkIcon, {
        size: iconSize,
        type: icon
      });
  }
};
export var getLeftIcon = function (role, icon, size) {
  var iconSize = size === 'small' ? 16 : 24;
  if (role === 'download') return null;
  switch (icon) {
    case 'back':
      return _jsx(LinkIcon, {
        size: iconSize,
        type: "icon-chevron-left-big"
      });
    default:
      return null;
  }
};